import fetch from 'auth/FetchInterceptor'

const AuthService = {}

AuthService.login = function (data) {
	return fetch({
		url: '/auth/login',
		method: 'post',
		data: data
	})
}

AuthService.register = function (data) {
	return fetch({
		url: '/auth/register',
		method: 'post',
		data: data
	})
}

AuthService.verifyUserDevice = function (data) {
	return fetch({
		url: '/auth/verify-user-device',
		method: 'post',
		data
	})
}

AuthService.resendCode = function (data) {
	return fetch({
		url: '/auth/resend-user-code',
		method: 'post',
		data
	})
}

AuthService.signOut = function (data) {
	return fetch({
		url: '/auth/logout',
		method: 'post',
		data
	})
}

export default AuthService;